import { ConversationSlaSnapshotServer } from '../conversationSla';
import { WsEvent, WsEventBase } from '../ws/server';

export type MarkNoteMentionsReadResponseServer = {
  /** Суммарное количество упоминаний в заметках всех пользователей менеджера */
  has_note_mentions: boolean;
  note_mentions_count: number;
};

export type ManagerNotificationsSubscriptionResponseServer = {
  channel: string;
  token: string;
};

export type ManagerNotificationsStateServer = {
  has_unread_conversations: boolean;
  /** Точное число, в отличие от списка ниже */
  unread_conversations_count: number;
  /** Обрезан бэком до 500: обрезание видно по count > length */
  unread_conversation_ids: number[];
  has_note_mentions: boolean;
  note_mentions_count: number;
  /**
   * Счётчики SLA уже отфильтрованы бэком под роль: назначенному оператору его
   * предупреждения, Владельцам и Администраторам остальное и все нарушения.
   * Роль на фронте не вычисляем.
   */
  sla_warning_count: number;
  /** Обрезан бэком до 500, как и список непрочитанных: count > length */
  sla_warning_conversation_ids: number[];
  sla_violation_count: number;
  sla_violation_conversation_ids: number[];
  updated_at: string;
};

export enum ManagerNotificationType {
  unreadConversation = 'unread_conversation',
  noteMention = 'note_mention',
  slaWarning = 'sla_warning',
  slaViolation = 'sla_violation'
}

export type ManagerNotificationEventData = {
  /** Для идемпотентной обработки: одно событие может прийти повторно после reconnect */
  event_id: string;
  type: ManagerNotificationType;
  user_id: string;
  /** Заполнен для unread_conversation, null для note_mention */
  conversation_id: number | null;
  /** Заполнен для note_mention, null для остальных типов */
  note_id: string | null;
  created_at: string;
  /** Только у sla_warning и sla_violation */
  timer_id?: string | null;
  sla?: ConversationSlaSnapshotServer | null;
};

export type ManagerNotificationEventServer = WsEventBase<
  WsEvent.managerNotification,
  ManagerNotificationEventData
>;

export enum UserListFillEventType {
  finished = 'finished',
  failed = 'failed'
}

export type UserListFillEventData = {
  event_id: string;
  type: UserListFillEventType;
  project_id: string;
  list_id: string;
  list_name: string;
  job_key: string;
  added_count: number;
  limit_reached: boolean;
  error_code: string | null;
  finished_at: string;
};

export type UserListFillEventServer = WsEventBase<
  WsEvent.userListFill,
  UserListFillEventData
>;

export type ManagerNotificationsEventServer =
  | ManagerNotificationEventServer
  | UserListFillEventServer;
